import type { ReactNode } from "react";
import { useStationStore } from "../state/station-store";
import { ContentValidateContext } from "@/features/verification/context/ContentValidateContext";
import { useContentValidateBundle } from "@/features/verification/hooks/useContentValidateBundle";

/**
 * F-013 / Wave F 19e — provides the job's content-validate bundle to every
 * station surface. Originally mounted inside TransactionPanes, which is keyed
 * to the ACTIVE transaction — so the bundle refetched on every transaction
 * switch and the empty-state <main> had no provider at all. Hoisted to the
 * station root: one fetch per batch, context spans list/panes/panel.
 */
export function StationContentValidateProvider({ children }: { children: ReactNode }) {
  const jobTypeId = useStationStore((s) => s.payload?.batch.jobTypeId ?? null);
  const { rules } = useContentValidateBundle(jobTypeId);
  return <ContentValidateContext.Provider value={rules}>{children}</ContentValidateContext.Provider>;
}
